import './Map.scss';
import { useContext, useMemo } from "react";
import Context from "../../context";
import { useParams } from "react-router-dom";
import MapScreen from '../Map';

const Map = () => {
  const { itin } = useContext(Context);
  const { slideNum } = useParams();

  const { locationId, dayMapConfig } = useMemo(() => {
    const briefItem = itin.brief[parseInt(slideNum) - 1];
    const mapConfig = briefItem?.map;

    if (mapConfig?.locations?.length) {
      const primaryLocation = itin.locations.find(loc => loc.id === mapConfig.locations[0]);
      return { locationId: primaryLocation?.id, dayMapConfig: mapConfig };
    }

    // Fallback to locationId
    const location = itin.locations.find(loc => loc.id === briefItem?.locationId);
    return { locationId: location?.id, dayMapConfig: null };
  }, [itin.brief, itin.locations, slideNum]);

  if (!locationId) return <div>Loading</div>;

  return <MapScreen key={slideNum} type="daily" locationId={locationId} dayMapConfig={dayMapConfig} />;
};

export default Map;
